import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-info-modal',
  standalone: true,
  imports: [],
  templateUrl: './info-modal.component.html',
  styleUrl: './info-modal.component.scss'
})
export class InfoModalComponent implements OnInit {
  title!: string;
  message!: string;
  closeOK?: string = 'Ok';
  result!: Subject<boolean>;
  sanitizedMessage!: SafeHtml;

  constructor(
    public bsModalRef: BsModalRef,
    private sanitizer: DomSanitizer,
  ) {}
  ngOnInit(): void {
    this.sanitizedMessage = this.sanitizer.bypassSecurityTrustHtml(
      this.message,
    ); // Sanitize HTML
  }

  onOK(): void {
    this.result.next(true); // Emit true
    this.bsModalRef.hide();
  }
}
